<template>
	<div class="product">
		<table class="table-main">
			<thead>
				<tr>
					<th>제품항번</th>
					<th>제품</th>
					<th>이미지</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(product, index) in data" :key="index">
					<td>{{ product.idProduct }}</td>
					<td>{{ product.productTitle }}</td>
					<td>
						<img :src="product.imageUrl" alt="product image" />
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import { mapState } from 'vuex';

	export default {
		computed: {
			...mapState({
				data: state => state.modal.params,
			}),
		},
	};
</script>
<style lang="scss" scoped>
	img {
		width: 80px;
	}
</style>
